/**
 * Company ids are Meteor `Random.id()` (17 alphanumerics) or Mongo ObjectIds (24 hex).
 * Anything shorter is not a sub-account id.
 */
const COMPANY_ID_PATTERN = /^[A-Za-z0-9]{17,24}$/;

/**
 * Reads a sub-account id from a URL param, or `undefined` when the value is not an id.
 *
 * #2679 — the "Request billing information" email links the NEW sub-account's own owner to
 * `/app/s/payment?s=1`. Read as an id, `s=1` sent `subAccountId: "1"` on every billing call and the
 * page rejected all of them, so the owner could not add a card. `1` is a flag, not an id: ignoring it
 * opens the owner's own payment page, which also fixes links in emails already sent.
 */
export function readSubAccountIdParam(value: string | null): string | undefined {
  return value && COMPANY_ID_PATTERN.test(value) ? value : undefined;
}
